export default {
  title: 'Your order',
  price: 'Price:',
  total: 'Total:',
  pay: 'Pay',
  back: 'Back',
  areYouSure: 'Are you sure you want to delete this item?',
};
